module.exports = __webpack_public_path__ + "img/environment_indoor2.615aff5c.jpg";